import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["rocketReact", "checkmarkReact"];
  }
  //Load the React code when we initialize
  initialize(){
    console.log("Animations controller initialized");
    this.reactComponentPromise = import("../react/AnimationsOnlyComponent");
  }
  async connect(){
    this.reactComponent = await this.reactComponentPromise;

    const rocketReact = this.hasRocketReactTarget && this.rocketReactTarget;
    const checkmarkReact = this.hasCheckmarkReactTarget && this.checkmarkReactTarget;

    if (rocketReact) {
      this.reactComponent.render(rocketReact, "rocket");
    } else if (checkmarkReact) {
      this.reactComponent.render(checkmarkReact, "checkmark");
    }
    
  }
  disconnect(){
    const rocketReact = this.hasRocketReactTarget && this.rocketReactTarget;
    const checkmarkReact = this.hasCheckmarkReactTarget && this.checkmarkReactTarget;

    if (rocketReact) {
      this.reactComponent.destroy(rocketReact);
    } else if (checkmarkReact) {
      this.reactComponent.destroy(checkmarkReact);
    }

  }
}
